import { Skeleton } from '@robinpowered/design-system';

export const LoaderSmall = (): JSX.Element => {
  return <Skeleton width={585} height={95} marginBottom={24} />;
};
